import React from 'react'
import { 
  FiX, 
  FiTag, 
  FiClock, 
  FiDollarSign, 
  FiSave,
  FiLoader,
  FiAlertCircle,
  FiTrendingUp,
  FiAward,
  FiZap,
  FiHash
} from "react-icons/fi";
import { 
  MdOutlineDiscount, 
  MdOutlineAccessTime,
  MdOutlineAttachMoney,
  MdOutlineClose,
  MdOutlineSave,
  MdOutlineAdd,
  MdOutlineLocalOffer
} from "react-icons/md";
import { IoRocketOutline, IoTimerOutline, IoCashOutline } from "react-icons/io5";
import InputField from '../../../components/ui/Input'

const CreatePromoModal = ({ onCancel, onSubmit, title, inputData, handleONChange, loading = false }) => {
  // Check if form is valid
  const isFormValid = inputData?.boostName?.trim() && inputData?.boostPeriod && inputData?.boostCharge;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl animate-in zoom-in-95 duration-200 max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-xl">
              <IoRocketOutline className="w-5 h-5 text-[#715EFE]" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
              <p className="text-xs text-gray-400 hidden sm:block">
                Create a new boost promotion
              </p>
            </div>
          </div>
          <button
            aria-label="Close modal"
            className="flex items-center justify-center w-9 h-9 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all duration-200"
            onClick={onCancel}
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {/* Boost Name */}
          <div>
            <label className="flex items-center gap-2 mb-1.5 text-sm font-medium text-gray-700">
              <FiTag className="w-4 h-4 text-gray-400" />
              <span>Boost Name</span>
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <FiAward className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                name="boostName"
                value={inputData?.boostName || ""}
                onChange={handleONChange}
                placeholder="Enter boost name..."
                className="w-full pl-10 pr-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              />
            </div>
          </div>

          {/* Boost Period */}
          <div>
            <label className="flex items-center gap-2 mb-1.5 text-sm font-medium text-gray-700">
              <FiClock className="w-4 h-4 text-gray-400" />
              <span>Duration (Days)</span>
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <IoTimerOutline className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="number"
                name="boostPeriod"
                value={inputData?.boostPeriod || ""}
                onChange={handleONChange}
                placeholder="Enter number of days..."
                min="1"
                className="w-full pl-10 pr-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              />
            </div>
          </div>

          {/* Boost Charge */}
          <div>
            <label className="flex items-center gap-2 mb-1.5 text-sm font-medium text-gray-700">
              <FiDollarSign className="w-4 h-4 text-gray-400" />
              <span>Price</span>
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <IoCashOutline className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="number"
                name="boostCharge"
                value={inputData?.boostCharge || ""}
                onChange={handleONChange}
                placeholder="Enter price..."
                min="0"
                step="0.01"
                className="w-full pl-10 pr-4 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              />
            </div>
          </div>

          {/* Form Validity Indicator */}
          {!isFormValid && (
            <div className="flex items-center gap-3 p-3 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-xl animate-in fade-in duration-200">
              <FiAlertCircle className="w-5 h-5 text-amber-500 flex-shrink-0" />
              <p>Please fill in all required fields to create a boost</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex flex-col-reverse sm:flex-row items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 flex-shrink-0 bg-gray-50/50 rounded-b-2xl">
          <button
            className="w-full sm:w-auto px-6 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all duration-200"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2.5 text-sm font-medium text-white rounded-lg transition-all duration-200 ${
              isFormValid && !loading
                ? 'bg-gradient-to-r from-[#855DF6] to-[#715EFE] hover:shadow-lg hover:shadow-[#715EFE]/25 hover:-translate-y-0.5'
                : 'bg-gray-300 cursor-not-allowed opacity-70'
            }`}
            onClick={onSubmit}
            disabled={!isFormValid || loading}
          >
            {loading ? (
              <>
                <FiLoader className="w-4 h-4 animate-spin" />
                <span>Generating...</span>
              </>
            ) : (
              <>
                <FiSave className="w-4 h-4" />
                <span>Generate Code</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CreatePromoModal